<template>
    <div>
        <div class="right author-right" v-if="!booklist || booklist.length == 0">
            <div class="book-header">
                <p>我的作品</p>
                <div class="cjxs-btn">
                    <router-link :to="'/author/create/0'">
                        <img src="@/assets/author/ic_cjxs.png" />
                        创建新书
                    </router-link>
                </div>
            </div>
            <div class="datanull">
                <img class="" src="@/assets/author/no-data.png" />
                <p style="margin-top: 28px">暂无作品</p>
                <p class="creat-btn">
                    <router-link :to="'/author/create/0'">去创建</router-link>
                </p>
            </div>
        </div>
        <div class="right author-right" v-else>
            <div class=" book-header ">
                <p>我的作品</p>
                <div class="cjxs-btn">
                    <router-link :to="'/author/create/0'">
                        <img src="@/assets/author/ic_cjxs.png" />
                        创建新书
                    </router-link>
                </div>
            </div>
            <ul class="collectlist mywrite clearfix">
                <li class="flexible f-csp" v-for="book in booklist"
                    @click.stop="goBookSet(book, 'list')">
                    <div class="book-cover">
                        <img :src="`${book.iiconUrlMedium}`" />
                    </div>
                    <div class="book-info ml30 flex">
                        <div class="name f16 text-333">{{ book.iname }}</div>
                        <div class="words f14 text-999"> {{ book.chapterCount }} 章 ｜ {{ book.words }} 字 </div>
                        <div class="error f14" v-if="book.inspectStatus == -2 ">审核驳回：{{ book.comment }}</div>
                        <div class="status f14 text-999">
                            <!-- 作品状态：{{book.inspectStatus == 1 ? '审核中': book.inspectStatus == 2 ? '审核成功' : book.inspectStatus == -2 ? '审核驳回' : book.inspectStatus == 0 ? '待提审':''}} -->
                           作品状态：{{book.inspectDesc}}<span v-if='book.sign'>/{{ book.sign ? '已签约':'' }}</span>
                        </div>
                        <div class="btns flexible">
                            <div class="btn-default" @click.stop="goBookSet(book, 'list')">章节列表</div>
                            <div class="btn-default"  v-if="book.inspectStatus != 1" @click.stop="goBookSet(book, 'edit')">编辑作品</div>
                            <div class="btn-default"  @click.stop="goReview(book)">提交审核</div>
                            <div class="btn-error"    v-if="(!book.open && !book.sign && book.inspectStatus <=0 )" @click.stop="del(book)">删除</div>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- <el-pagination
                background
                layout="total, jumper, prev, pager, next"
                :page-sizes="[10, 20, 30, 50 ,100]"
                :total="total"
                class="paginnation-book sortpage"
                :current-page.sync="queryParams.pageNo"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
            >
            </el-pagination> -->
            <pagination  v-show="total>0" :total="total" :page.sync="queryParams.pageNo"
            :limit.sync="queryParams.pageSize" @pagination="getwriteList()" />
        </div>

        <!-- <pagination class="fr" v-show="total>0" :total="total" :page.sync="queryParams.pageNo"
            :limit.sync="queryParams.pageSize" @pagination="getwriteList()" /> -->
        <!-- <addEmail ref="addEmail" v-if="ispopshow" :book="book" @closeEmail="closeEmail"></addEmail> -->
    </div>
</template>

<script>
    import baseURL from "@/api/env";
    // import addEmail from "./addEmail";
    import {
        BookApplyApi,
        delBookApi,
        authorBookListApi
    } from '@/api/author'
    // import { authorBookListApi } from 'apiurl/author';
    import Pagination from "@/components/Pagination/index"
    import {
        hideLoading,
        showLoading
    } from "@/utils/load";

    export default {
        // props: {
        //     booklist: {
        //         type: Array,
        //         default: () => {
        //             return null;
        //         }
        //     },
        //     isSign: Boolean,
        //     small: Boolean
        // },
        data() {
            return {
                book: {},
                booklist:null,
                /*分页*/
                queryParams:{
                    pageNo:1,
                    pageSize:10,
                    // total:""
                },
                // totalPage: 0,
                // busy: false,
                // pageNo: 1,
                total:0
            }
        },
        components: {
            Pagination
        },
        created() {
            this.getwriteList();

        },
        //   components: {addEmail},
        methods: {
            // 获取作者写书列表
            async getwriteList(val) {
                showLoading()
                let res = await authorBookListApi({
                    pageSize: this.queryParams.pageSize,
                    pageNo: this.queryParams.pageNo
                });
                if (res.success) {
                    hideLoading()
                    if (res.data) {
                        this.booklist = res.data.items
                    }else{
                        this.booklist = null;
                    }
                    this.total = Number(res.data.totalCount);
                }
            },
            goBookSet(book, flag) {
                if (flag == 'list') {
                    this.$router.push("/author/authorManage/chapterList/" + book.id);
                } else if (flag == 'edit') {
                    this.$router.push('/author/create/' + book.id)
                }
            },
            //提交审核
            goReview(item) {
                console.log(item)
                if (item.type==1&&(item.words < 8000||item.words>20000)) {
                    this.$faild('custom', '短篇书籍字数在8000-20000才能！')
                    return false;
                }else if (item.type==2&&(item.words < 20000||item.words>100000)) {
                    this.$faild('custom', '中篇书籍字数在20000-100000才能申请签约！')
                    return false;
                }
                let params = {
                    bookId: item.id
                }
                BookApplyApi(params)
                    .then(res => {
                        if (res.success) {
                            this.$success('custom', '提交审核成功')
                            // this.$emit('getwriteList')
                            this.getwriteList()
                        }
                    })
                    .catch(() => {});
            },
            del(item) {
                this.$confirm(`是否确认删除【${item.iname}】吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delBookApi(item.id)
                        .then(res => {
                            if (res.success) {
                                this.$success('custom', '删除作品成功')
                                this.getwriteList()
                                // this.$emit('getwriteList')
                            }
                        })
                        .catch(() => {});
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/styles/author.scss";

    .creat-btn {
        display: inline-block;
        width: 140px;
        height: 44px;
        line-height: 44px;
        background: #F68A01;
        border-radius: 22px;
        margin-top: 30px;
        cursor: pointer;

        a {
            color: #fff;
            font-size: 18px;
        }
    }

    .collectlist {
        margin-top: 40px;

        li {
            display: inline-block;
            width: 100%;
            height: 196px;
            background: #FBFBFB;
            border-radius: 4px;
            margin-bottom: 24px;
            padding: 16px 30px;
            box-sizing: border-box;

            .book-cover {
                width: 118px;
                height: 164px;

                img {
                    width: 118px;
                    height: 164px;
                }
            }

            .book-info {
                position: relative;

                .name {
                    line-height: 22px;
                    padding-top: 11px;
                }

                .words {
                    line-height: 20px;
                    padding-top: 12px;
                }

                .error {
                    color: #FF4646;
                    line-height: 20px;
                    padding-top: 7px;
                }

                .status {
                    position: absolute;
                    bottom: 0;
                    left: 0
                }

                .btns {
                    position: absolute;
                    bottom: 0;
                    right: 0;

                    div {
                        width: 90px;
                        height: 36px;
                        line-height: 36px;
                        text-align: center;
                        border-radius: 20px;
                        margin-left: 20px;
                        font-size: 14px;

                    }

                    .btn-default {
                        background: #F2F2F2 !important;
                        color: #333 !important;
                    }

                    .btn-succ {
                        background: #0E9A00 !important;
                        color: #fff !important;
                    }

                    .btn-error {
                        background: #FF4646 !important;
                        color: #fff !important;
                    }

                    .btn-default:hover {
                        background: #F68A01 !important;
                        color: #fff !important;
                    }

                }

                .book-deatil {
                    margin-top: 48px;

                    i {
                        font-size: 24px;
                        margin-right: 5px;
                    }

                    span {
                        margin-right: 20px;
                    }
                }
            }

            .book-btn {
                margin-top: 46px;

                a {
                    width: 180px;
                    height: 40px;
                    border-radius: 4px;
                    line-height: 40px;
                    display: block;
                    margin-right: 24px;
                    margin-bottom: 30px;

                    img {
                        margin-left: 13px;
                        margin-right: 10px;
                    }
                }

                .new-btn {
                    background: rgba(125, 179, 108, 0.1);
                    border: 1px solid #7DB36C;
                    color: #7DB36C;

                    img {
                        width: 15px;
                        height: 18px;
                    }
                }

                .new-dis-btn {
                    background: rgba(103, 103, 103, 0.1);
                    border: 1px solid rgba(103, 103, 103, 0.1);
                    color: #999;

                    img {
                        width: 15px;
                        height: 18px;
                    }
                }

                .list-btn {
                    background: rgba(50, 195, 146, 0.1);
                    border: 1px solid #32C392;
                    color: #32C392;

                    img {
                        width: 18px;
                        height: 17px;
                    }
                }

                .Edit-btn {
                    background: rgba(244, 120, 116, 0.1);
                    border: 1px solid #F47874;
                    color: #F47874;

                    img {
                        width: 17px;
                        height: 17px;
                    }
                }
            }
        }
    }
</style>
